<div class="mail-list-container">
  <!-- Buscador en cabecera del maestro -->
  <div class="mb-2">
    <div class="input-group input-group-sm">
      <span class="input-group-text bg-white border-end-0 text-muted">
        <i class="fas fa-search"></i>
      </span>
      <input type="text"
             class="form-control border-start-0 ps-0"
             placeholder="Buscar destinatario o asunto..."
             [ngModel]="searchQuery"
             (ngModelChange)="onSearch($event)">
      @if (searchQuery) {
        <button type="button" class="btn btn-outline-secondary border-start-0" (click)="onSearch('')">
          <i class="fas fa-times"></i>
        </button>
      }
    </div>
  </div>

  <!-- Badges de estado -->
  <div class="badges-scroll-container mb-2">
    @for (filter of statusFilters; track filter.name) {
      <span class="filter-badge"
            role="button"
            tabindex="0"
            [class.active]="activeStatus === filter.slug"
            (click)="toggleStatus(filter.slug)">
        {{ filter.name }}
      </span>
    }
  </div>

  <!-- Contenedor con scroll infinito -->
  <div class="mail-cards-scroll" (scroll)="onScroll($event)">
    @if (loading && !items.length) {
      @for (i of [1, 2, 3, 4, 5]; track $index) {
        <app-list-card [isLoading]="true"></app-list-card>
      }
    } @else if (!items.length) {
      <div class="text-center py-5 text-muted small">
        <i class="fas fa-inbox fa-2x mb-2 text-secondary opacity-50"></i>
        <div>No se encontraron correos.</div>
      </div>
    } @else {
      @for (item of items; track item.uuid) {
        <app-list-card
         [isShortcut]="appSettings.isMobile()"
          [customClass]="selectedUuid === item.uuid ? 'list-card-selected' : ''"
          (click)="onSelect(item)">
          <div cardTitle class="fw-bold text-dark text-truncate">
            @if (item.hasAttachment) {
              <i class="fas fa-paperclip text-info me-1" [ngbTooltip]="item.attachmentName || 'Adjunto'"></i>
            }
            {{ item.subject || '(Sin asunto)' }}
          </div>

          <div cardBadge class="d-flex gap-1">
            @if (item.entityCode) {
              <span class="badge bg-light text-dark border">{{ item.entityCode }}</span>
            }
          </div>

          <div class="text-muted small text-truncate">
            Para: <strong class="text-dark">{{ item.toMail || '(Sin destinatario)' }}</strong>
          </div>

          <div class="text-muted small text-truncate mt-1">
            <i class="fa fa-calendar me-1"></i>{{ (item.sentAt || item.createdAt) | date:'dd/MM/yyyy HH:mm' }}
            @if (item.category) {
              <span class="mx-1">·</span>
              <span>{{ item.category }}</span>
            }
          </div>

          <span cardExtra class="text-uppercase fw-semibold text-muted" style="font-size: 0.75rem;">
            ESTADO
          </span>
          <div cardAmount>
            @if (item.status === 'SENT') {
              <span class="badge border border-success text-success">ENVIADO</span>
            } @else if (item.status === 'FAILED') {
              <span class="badge border border-danger text-danger">FALLIDO</span>
            } @else {
              <span class="badge border border-warning text-warning">OMITIDO</span>
            }
          </div>
        </app-list-card>
      }

      @if (loadingMore) {
        <div class="text-center py-2 text-muted small">
          <span class="spinner-border spinner-border-sm me-1 text-primary"></span> Cargando más...
        </div>
      }
    }
  </div>

  <div class="pt-2 text-center text-muted small border-top mt-1">
    Total Registros: {{ total }}
  </div>
</div>
